import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Save settings to localStorage
export const saveSettings = (settings: Record<string, any>, key = 'ulixes_settings') => {
  try {
    localStorage.setItem(key, JSON.stringify(settings));
    return true;
  } catch (error) {
    console.error('Error saving settings to localStorage:', error);
    return false;
  }
};

// Load settings from localStorage
export const loadSettings = (key = 'ulixes_settings'): Record<string, any> => {
  try {
    const settings = localStorage.getItem(key);
    return settings ? JSON.parse(settings) : {};
  } catch (error) {
    console.error('Error loading settings from localStorage:', error);
    return {};
  }
};

export const getRandomTravelerName = () => {
  const firstNames = [
    "Zephyrus", "Nyx", "Ember", "Solara", "Lunara", "Drakonis", "Nimbus",
    "Orionis", "Aether", "Noctis", "Sylva", "Eldrin", "Mirage", "Thalorin"
  ];

  const lastNames = [
    "Stormrider", "Shadowtail", "Starborne", "Duskwhisper", "Solwanderer",
    "The Wanderer", "Cloudpiercer", "Ironbloom", "Voidwalker", "Thundersong",
    "Skyseeker", "Runebound", "Ashenwing", "Frostfang", "Everflame"
  ];

  const randomFirst = firstNames[Math.floor(Math.random() * firstNames.length)];
  const randomLast = lastNames[Math.floor(Math.random() * lastNames.length)];

  return `${randomFirst} ${randomLast}`;
};
